module.exports = __webpack_public_path__ + "static/media/test_hov.73551549.jpg";